import { Field } from 'formik';
import styled, { css } from 'styled-components/macro';

export const Input = styled(Field)`
  position: absolute;

  width: 100%;
  height: 100%;

  cursor: pointer;

  opacity: 0;
`;

export const PickerWrapper = styled.div`
  position: relative;

  width: 2.5rem;
  height: 2rem;
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme }) => theme.colors.black_80};
  font-size: ${({ theme }) => theme.fontSize.xs};

  &:hover {
    div {
      background-color: ${({ theme }) => theme.colors.black_20};
    }
  }

  input:checked ~ div {
    border: none;

    color: ${({ theme }) => theme.colors.white};

    background-color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-left: ${({ theme }) => theme.spacing.zero};
  }
`;

export const ChoiceBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2.5rem;
  height: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.black_40};
  border-radius: 4px;

  background-color: ${({ theme }) => theme.colors.white};
`;

export const ChoiceBoxLabel = styled.p<{ error?: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme, error }) => (error ? theme.colors.negative_dark : theme.colors.black_60)};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.medium};
`;

export const Asterisk = styled.i`
  color: ${({ theme }) => theme.colors.negative_dark};
  font-style: normal;
`;

const PickerErrorContainer = css`
  height: 1rem;
`;

export const PickerErrorEmpty = styled.div`
  ${PickerErrorContainer};
`;

export const PickerError = styled.p`
  ${PickerErrorContainer};

  color: ${({ theme }) => theme.colors.negative_dark};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: ${({ theme }) => theme.lineHeight.zero_3};
`;
